import * as React from 'react';
import { motion } from 'motion/react';
import { getVariants, useAnimateIconContext, IconWrapper } from './AnimateIcon';

const animations = {
  default: {
    dot1: {
      initial: { y: 0 },
      animate: {
        y: [0, -3, 0],
        transition: { duration: 0.4, ease: 'easeInOut', delay: 0 },
      },
    },
    dot2: {
      initial: { y: 0 },
      animate: {
        y: [0, -3, 0],
        transition: { duration: 0.4, ease: 'easeInOut', delay: 0.1 },
      },
    },
    dot3: {
      initial: { y: 0 },
      animate: {
        y: [0, -3, 0],
        transition: { duration: 0.4, ease: 'easeInOut', delay: 0.2 },
      },
    },
  },
};

function IconComponent({ size, ...props }) {
  const { controls } = useAnimateIconContext();
  const variants = getVariants(animations);

  return (
    <motion.svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
      {...props}
    >
      <motion.circle cx={12} cy={5} r={1} variants={variants.dot1} initial="initial" animate={controls} />
      <motion.circle cx={12} cy={12} r={1} variants={variants.dot2} initial="initial" animate={controls} />
      <motion.circle cx={12} cy={19} r={1} variants={variants.dot3} initial="initial" animate={controls} />
    </motion.svg>
  );
}

function EllipsisVertical(props) {
  return <IconWrapper icon={IconComponent} {...props} />;
}

export { animations, EllipsisVertical, EllipsisVertical as EllipsisVerticalIcon };
